// const __PREFIX = process.env.REACT_APP_API_TABLE_PREFIX;
export const BASE_URL = (("development" === process.env.NODE_ENV) ? process.env.REACT_APP_API_URL : '/');

export async function jsonFetch<T = any | Array<any>>(url: string, body: { [k: string]: any } | null = null, method: 'GET' | 'POST' | 'PUT' = 'GET'): Promise<T> {
  const r = await fetch(`${BASE_URL}${url}`, {
    method: method,
    headers: {
      'content-type': 'application/json',
      'X-API-Key': localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth') as string).api_key : null,
    },
    body: body ? JSON.stringify(body) : null,
  });
  return await r.json();
}
export function authHeartbeat() {
  return Promise.resolve({});
}
export function authSignOut() {
  return Promise.resolve();
}
